export default {
  path: 'rack-eggs',
  name: 'incubator.rack-eggs',
  component: () => import('@/views/admin/incubators/rack-eggs/Index'),
}